import React, { useRef, useEffect, useState } from 'react'
import './App.css';
import speaker from './images/speaker.png'
import ytdl from 'ytdl-core'
import { Howl, Howler } from 'howler';
import axios from 'axios'

const API = 'https://room-of-slow-mood.herokuapp.com'

function App() {
  const playlist = useRef([]);
  const playid = useRef(0);
  const player = useRef(null);
  const [url, setUrl] = useState('')
  const [rate, setRate] = useState(0.65)
  const [title, setTitle] = useState('')
  const [status, setStatus] = useState('pending')

  function parse_str(str) {
    return str.split('&').reduce(function (params, param) {
      let paramSplit = param.split('=').map(function (value) {
        return decodeURIComponent(value.replace('+', ' '));
      });
      params[paramSplit[0]] = paramSplit[1];
      return params;
    }, {});
  }

  const getYoutubeStream = async (url) => {

    let audioURL = await axios.get(API + '/title?url=' + url)
      .then(response => {
        let title = response.data
        let audioStream = API + '/stream?url=' + url
        return [audioStream, title]
      }).catch(error => {
        console.log(error)
      });

    return audioURL
  }

  const playHandler = async (e) => {
    e.preventDefault();
    if(!url){
      return
    }
    setStatus('loading')
    setUrl('')
    if (player.current) {
      player.current.unload();
    }
    try {
      let [audioURL, videoTitle] = await getYoutubeStream(url);
      // playlist.current.push(audioURL);
      player.current = new Howl({
        src: [audioURL],
        html5: true,
        format: ['mp3'],
        volume: 0.5,
        rate: rate,
        onload: () => { onloadHandler(videoTitle) }
      })

      playid.current = player.current.play();

    } catch (error) {
      console.log(error)
    }
  }

  const roundDecimal = (val, precision) => {
    return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
  }

  const onloadHandler = (title) => {
    setStatus('playing')
    setTitle(title)
  }

  const rateHandler = (type) => {
    const offset = 0.05
    if (type === 'minus') {
      let newRate = roundDecimal(rate - offset, 2);
      setRate(newRate)
      if (player.current) {
        player.current.rate(newRate, playid.current)
      }
    } else if (type === 'plus') {
      let newRate = roundDecimal(rate + offset, 2);
      setRate(newRate)
      if (player.current) {
        player.current.rate(newRate, playid.current)
      }
    }
  }

  return (
    <div className="App">
      <div className="audioPlayer">
        <div className="audioPlayer__topContainer">
          <div className="audioPlayer__titleContainer">
            {status === 'loading' &&
              <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
            }
            {status === 'playing' &&
              <span>{title}</span>
            }
            {status === 'stoping' &&
              <span>{title}</span>
            }
          </div>
          <img className={`audioPlayer__image ${status === 'playing' ? 'playing' : ''}`} src={speaker} alt="speaker" />
          <div className="audioPlayer__controllerContainer">
            <a className="audioPlayer__button" onClick={() => {
              player.current.stop(playid.current)
              setStatus('stoping')
            }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="30px" height="30px">
                <path fillRule="evenodd" fill="rgb(207, 208, 203)"
                  d="M2.000,-0.000 L28.000,-0.000 C29.105,-0.000 30.000,0.895 30.000,2.000 L30.000,28.000 C30.000,29.105 29.105,30.000 28.000,30.000 L2.000,30.000 C0.895,30.000 -0.000,29.105 -0.000,28.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 Z" />
              </svg>
            </a>
            <a className="audioPlayer__button" onClick={() => {
              player.current.play(playid.current)
              setStatus('playing')
            }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="30px" height="31px">
                <path fill-rule="evenodd" fill="rgb(207, 208, 203)"
                  d="M29.803,15.375 L0.197,30.204 L0.197,0.546 L29.803,15.375 Z" />
              </svg>
            </a>
            <a className="audioPlayer__button" onClick={() => {
              player.current.pause(playid.current)
              setStatus('stoping')
            }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="21px" height="30px">
                <path fill-rule="evenodd" fill="rgb(207, 208, 203)"
                  d="M19.500,30.000 L15.500,30.000 C14.672,30.000 14.000,29.328 14.000,28.500 L14.000,1.500 C14.000,0.672 14.672,-0.000 15.500,-0.000 L19.500,-0.000 C20.328,-0.000 21.000,0.672 21.000,1.500 L21.000,28.500 C21.000,29.328 20.328,30.000 19.500,30.000 ZM5.500,30.000 L1.500,30.000 C0.672,30.000 -0.000,29.328 -0.000,28.500 L-0.000,1.500 C-0.000,0.672 0.672,-0.000 1.500,-0.000 L5.500,-0.000 C6.328,-0.000 7.000,0.672 7.000,1.500 L7.000,28.500 C7.000,29.328 6.328,30.000 5.500,30.000 Z" />
              </svg>
            </a>
          </div>
          {/* <div className="audioPlayer__rateControllerContainer">
            <div className="audioPlayer__title">Playback Rate</div>
            <div className="audioPlayer__wrap">
              <a className="audioPlayer__minus" onClick={() => { rateHandler('minus') }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="#cfd0cb" d="M0 10h24v4h-24z" /></svg>
              </a>
              <span className="audioPlayer__rate">{rate}</span>
              <a className="audioPlayer__plus" onClick={() => { rateHandler('plus') }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="#cfd0cb" d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" /></svg>
              </a>
            </div>
          </div> */}
        </div>
        <form className="audioPlayer__bottomContainer" onSubmit={playHandler}>
          <div className="audioPlayer__playLinkContainer">
            <input type="submit" className="audioPlayer__playLink" value="Play">
            </input>
          </div>
          <div className="audioPlayer__linkContainer">
            <input placeholder="paste your music link here" type="text" name="link" value={url} onChange={(e) => setUrl(e.target.value)} className="audioPlayer__link"></input>
          </div>
        </form>
      </div>
    </div>
  );
}

export default App;
